// Port JS del motor de compatibilidad por CAMINO (espejo de backend/cake_rules.py).
// Cada nivel depende de todo lo elegido antes. La verdad final la impone el backend.

function byId(options, dim) {
  const m = {};
  (options[dim] || []).forEach((o) => { m[o.id] = o; });
  return m;
}
function availableIds(options, dim) {
  return (options[dim] || []).filter((o) => o.available !== false).map((o) => o.id);
}
function filt(avail, allowed) {
  if (allowed == null) return avail;
  const s = new Set(allowed);
  return avail.filter((id) => s.has(id));
}

// Rellenos permitidos para el sabor (sin lista/sabor = todos los disponibles).
export function allowedRellenos(saborId, options) {
  const avail = availableIds(options, 'rellenos');
  const sabor = byId(options, 'sabores')[saborId];
  if (!sabor) return avail;
  return filt(avail, sabor.allowedRellenos);
}

// Coberturas permitidas para el camino (sabor, relleno). Ausente = todas.
export function allowedExteriores(saborId, rellenoId, options) {
  const avail = availableIds(options, 'exteriores');
  const sabor = byId(options, 'sabores')[saborId];
  if (!sabor) return avail;
  const allowed = (sabor.rellenoCoberturas || {})[rellenoId];
  return filt(avail, allowed);
}

// Toppings permitidos para el camino (sabor, relleno, cobertura). Ausente = todos.
export function allowedToppings(saborId, rellenoId, exteriorId, options) {
  const avail = availableIds(options, 'toppings');
  const sabor = byId(options, 'sabores')[saborId];
  if (!sabor) return avail;
  const byRelleno = (sabor.coberturaToppings || {})[rellenoId] || {};
  return filt(avail, byRelleno[exteriorId]);
}
